import { isEmpty } from 'lodash'

import { API_BASE_PATH_PORTAL } from '../../../api/auth'
import { axiosRequest } from '../../../utils/axiosRequest'

const fetchPeriods = async (partnerid: number, type: string, interval: string) => {
  const dateRanges = await axiosRequest(
    'get',
    `${API_BASE_PATH_PORTAL}/v2/reports/periods/${partnerid}/${interval}/${type}`
  )

  if (isEmpty(dateRanges.data)) return [{ label: 'No Date Ranges Available', value: '' }]

  const reformatted = dateRanges.data[type][interval].map(
    (entry: {
      reportPeriodId: string
      periodName: string
      periodStart: string
      periodEnd: string
    }) => {
      const label = `${entry.periodName}`

      return { label, value: `${entry.reportPeriodId}` }
    }
  )

  return reformatted
}

export const fetchSetOfPeriods = async (partnerId: number) => {
  return await {
    monthlyInterval: await fetchPeriods(partnerId, 'quarter', 'interval'),
    monthlyCalendar: await fetchPeriods(partnerId, 'quarter', 'calendar'),
    quarterlyInterval: await fetchPeriods(partnerId, 'year', 'interval'),
    quarterlyCalendar: await fetchPeriods(partnerId, 'year', 'calendar'),
  }
}

export const fetchReports = async (partnerId: number, reportPeriodId: string) => {
  const data = await axiosRequest('post', `${API_BASE_PATH_PORTAL}/v2/reports`, {
    reportPeriodId,
    partnerId,
    bucket: true,
  })

  return data?.data
}

export const fetchAggregateReports = async (partnerId: number) => {
  const data = await axiosRequest('post', `${API_BASE_PATH_PORTAL}/v2/reports`, {
    partnerId,
    isAggregate: true,
    bucket: true,
  })

  return data?.data
}
